export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  processFormValues() {
    const { age } = this.formValues
    return { age }
  },
})
